"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const CheckboxForm_1 = __importDefault(require("@App/kit/fields/v2/CheckboxForm"));
const FormFieldFromProps_1 = __importDefault(require("@App/kit/fields/v2/FormFieldFromProps"));
const TermsAndCommunicationsSection = (props) => {
    const { termsAndConditions, privacyPolicy, emailCommunications } = props;
    return (react_1.default.createElement("div", { className: "checks-wrapper" },
        react_1.default.createElement("div", { className: "checkbox" },
            react_1.default.createElement(CheckboxForm_1.default, Object.assign({}, termsAndConditions),
                react_1.default.createElement("a", { href: "https://www.themlc.com/portaltermsofuse", target: '_blank', className: "small", rel: "noreferrer" }, "Terms of Use"))),
        react_1.default.createElement("div", { className: "checkbox" },
            react_1.default.createElement(CheckboxForm_1.default, Object.assign({}, privacyPolicy),
                react_1.default.createElement("a", { href: "https://www.themlc.com/privacy-policy", target: '_blank', className: "small", rel: "noreferrer" }, "Privacy Policy"))),
        react_1.default.createElement("div", { className: "checkbox" },
            react_1.default.createElement(FormFieldFromProps_1.default, { field: emailCommunications }))));
};
exports.default = TermsAndCommunicationsSection;
